
import { Modal, Box, Typography} from "@mui/material";
import { useState } from "react";
import StepWizard from "react-step-wizard";
import HowItWorksCard from "../HowItWorksCard";
import { css } from "@emotion/react";

const HowItWorksModal = () => {

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const args = {
        open: open,
        onClose: handleClose,
        id: "howitworks-modal"
    };

    const buttonSyle = css({
        visibility: 'hidden'
    });

    const stepWizardTransitions = {
        enterRight: "fade-in",
        enterLeft: "fade-in",
        exitRight: "fade-out",
        exitLeft: "fade-out",
    };
      

    return (
        <>
        <button id="howitworks-trigger" css={buttonSyle} onClick={handleOpen}></button>
        <Modal {...args}>
            <Box sx={{padding: "0 !important", borderRadius: "0 !important",  maxWidth: "382px !important", backgroundColor: "transparent !important"}}>
                <StepWizard transitions={stepWizardTransitions}>
                    <HowItWorksCard handleClose={handleClose} img="/view-tutors/howitworks-welcome.svg">
                        <Typography variant="h3" mb="0.5rem">
                        Welcome to MyTutor
                        </Typography>
                        <Typography variant="text1" mb="1.5rem">
                            You&apos;re just a step away from tutoring that transforms grades and confidence.
                        </Typography>
                    </HowItWorksCard>
                    <HowItWorksCard handleClose={handleClose} img="/view-tutors/howitworks-discover.svg" currentStage="Step 1 of 3">
                        <Typography variant="h3" mb="0.5rem">
                            Discover
                        </Typography>
                        <Typography variant="text1" mb="1.5rem">
                            On this page you can browse the list of tutors we&apos;ve matched to your needs
                        </Typography>
                    </HowItWorksCard>
                    <HowItWorksCard handleClose={handleClose} img="/view-tutors/howitworks-shortlist.svg" currentStage="Step 2 of 3">
                        <Typography variant="h3" mb="0.5rem">
                            Shortlist
                        </Typography>
                        <Typography variant="text1" mb="1.5rem">
                            Use the filters to narrow down your options by price, availability and gender
                        </Typography>
                    </HowItWorksCard>
                    <HowItWorksCard handleClose={handleClose} img="/view-tutors/howitworks-reach-out.svg" currentStage="Step 3 of 3">
                        <Typography variant="h3" mb="0.5rem">
                            Reach out
                        </Typography>
                        <Typography variant="text1" mb="1.5rem">
                            When you find a tutor you’re interested in, drop them a message to find out more!
                        </Typography>
                    </HowItWorksCard>
                    <HowItWorksCard handleClose={handleClose} img="/view-tutors/howitworks-top-tip.svg">
                        <Typography variant="h3" mb="0.5rem">
                            Top tip
                        </Typography>
                        <Typography variant="text1" mb="1.5rem">
                            We recommend messaging between 3-5 tutors to increase your chances of finding the right match
                        </Typography>
                    </HowItWorksCard>

                </StepWizard>
            </Box>
        </Modal>
    </>
    )
};

export default HowItWorksModal;
